import {
    flattenStatusTree,
    LEGACY_STATUS_MAP,
    statusLabel,
    statusStage,
    statusTone,
} from "./candidateStatuses";

/**
 * Build funnel rows in hierarchy order for analytics UI.
 * @param {Record<string, number>|null|undefined} stats
 */
export function buildCandidateFunnelRows(stats) {
    const map = stats && typeof stats === "object" ? stats : {};
    const normalized = {};
    for (const [value, count] of Object.entries(map)) {
        const status = LEGACY_STATUS_MAP[value] || value;
        normalized[status] = (normalized[status] || 0) + (Number(count) || 0);
    }
    const knownRows = flattenStatusTree().filter((row) => row.value).map((row) => ({
        value: row.value,
        name: statusLabel(row.value),
        count: normalized[row.value] || 0,
        depth: row.depth,
        hasChildren: row.hasChildren,
        stage: statusStage(row.value),
        tone: statusTone(row.value),
    }));
    const knownValues = new Set(knownRows.map((row) => row.value));
    const unknownRows = Object.entries(normalized)
        .filter(([value]) => !knownValues.has(value))
        .map(([value, count]) => ({
            value,
            name: statusLabel(value) || value,
            count,
            depth: 0,
            hasChildren: false,
            stage: "Другие статусы",
            tone: "grey",
        }));

    return [...knownRows, ...unknownRows];
}

export function totalFunnelCount(rows) {
    return (rows || []).reduce((sum, row) => sum + (Number(row.count) || 0), 0);
}
